// extracted by mini-css-extract-plugin
module.exports = {"DownloadButtonArea":"Page_DownloadButtonArea__lWXVv"};